module.exports = __webpack_public_path__ + "img/loading.31cdfb1e.gif";